import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'react-bootstrap';
import CustomAccordionToggle from '../../../components/containers/CustomAccordionToggle';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface HeaderProps {
    expanded: boolean;
    displayName: string;
    showTimeStamp: boolean;
}

const Header = ({ displayName, showTimeStamp, expanded }: HeaderProps) => {
    return (
        <Row className="align-items-center">
            <Col
                xs={12}
                sm={{ offset: 4, span: 3 }}
                md={{ offset: 4, span: 4 }}
                className="text-center"
            >
                <h4 className="d-inline-flex px-1">{displayName}</h4>
                <FontAwesomeIcon icon={(expanded ? faChevronUp : faChevronDown) as IconProp} />
            </Col>
            {/* shows the last page refresh time if the match is in progress & only on the last quarter */}
            {showTimeStamp ? (
                <Col xs={12} sm={5} md={4} className="text-center text-sm-right">
                    Last Refreshed{' '}
                    {new Date().toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                    })}
                </Col>
            ) : (
                <></>
            )}
        </Row>
    );
};

interface Props {
    displayName: string;
    showTimeStamp: boolean;
    eventKey: string;
    initialExpandedState: boolean;
}

const MatchStatListAccordionHeader = ({
    eventKey,
    displayName,
    showTimeStamp,
    initialExpandedState,
}: Props) => {
    const [expanded, setExpanded] = useState(initialExpandedState);
    return (
        <CustomAccordionToggle
            eventKey={eventKey}
            callback={(expandedVal) => {
                setExpanded(expandedVal);
            }}
        >
            <Header displayName={displayName} showTimeStamp={showTimeStamp} expanded={expanded} />
        </CustomAccordionToggle>
    );
};

export default MatchStatListAccordionHeader;
